import React, { useCallback, useEffect, useState } from "react";
import { Paper } from "@mui/material";

import RGL, { WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";

import { produce } from "immer";
import Widget from "./Widget";

import useStore from "../../store";

const ReactGridLayout = WidthProvider(RGL);

function GridLayout(props) {
    const { section, cols, enabled } = props;
    const storeWidgets = useStore(useCallback(
        (store) => store.dashboard.widgets[section],
        [section],
    ));
    const dashboardId = useStore((store) => store.dashboard.id);
    const isHelpDesk = useStore((store) => store.app.appInfo.is_helpdesk);

    const showWidget = useStore((store) => store.dashboard.widgets.show);
    const hideWidget = useStore((store) => store.dashboard.widgets.hide);
    const updatePositionsWidget = useStore((store) => store.dashboard.widgets.updatePositions);
    const [widgets, setWidgets] = useState([]);
    const [layout, setLayout] = useState([]);

    useEffect(() => {
        let i = 0;
        const tmpWidgets = produce(storeWidgets, (draft) => {
            draft.forEach((item) => {
                if (item.component === "TasksList") {
                    item.index = i;
                    i++;
                }
                if (item.isHidden) {
                    item.positions.isResizable = false;
                    item.positions.h = 1;
                }
            });
        });
        // if (dashboardId !== currentId) {
        setWidgets(tmpWidgets);
        // setCurrentId(dashboardId);
        // }

        setLayout(tmpWidgets.map((widget) => ({
            i: widget.id.toString(),
            ...widget.positions,
        })));
    }, [storeWidgets, dashboardId]);

    const onLayoutChange = (changedLayout) => {
        updatePositionsWidget(section, changedLayout);
    };

    useEffect(() => {
        setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        }, 250);
    }, []);

    function onHideWidget(widgetId) {
        hideWidget(section, widgetId);
    }

    const onShowWidget = (widgetId) => {
        showWidget(section, widgetId);
    };
    return (
        <ReactGridLayout
            className="layout"
            cols={parseInt(cols)}
            rowHeight={30}
            isBounded
            verticalCompact
            draggableHandle=".rgl-drag-handle"
            draggableCancel=".noDrag"
            onDragStop={onLayoutChange}
            onResizeStop={onLayoutChange}
            isDraggable={!isHelpDesk}
            isResizable={!isHelpDesk}
            layout={layout}
        >
            {React.useMemo(() => widgets.map((widget) => (
                <Paper
                    key={widget.id}
                >
                    <Widget
                        widget={widget}
                        hideWidget={onHideWidget}
                        showWidget={onShowWidget}
                        section={section}
                        enabled={enabled === undefined ? true : enabled}
                    />
                </Paper>
            )), [widgets, enabled])}
        </ReactGridLayout>
    );
}

export default React.memo(GridLayout);
